const trust_interval = setInterval(() => {
  const trust_pilot_wrap = document.querySelector(
    ".scrollable-with-controls scroll-carousel #trustpilot-widget-trustbox-2-wrapper"
  );
  if (trust_pilot_wrap) {
    if (window.innerWidth < 768) {
      document.querySelector(
        ".scrollable-with-controls scroll-carousel"
      ).scrollLeft = 0;
      clearInterval(trust_interval);
    }
  }
}, 500);

const select = document.querySelector(".wav-showing-status");
const options = document.querySelector(".wav-languages");

select.addEventListener("click", () => {
  options.classList.toggle("active");
});

options.addEventListener("click", (e) => {
  const parent = e.target.closest('button')
  const value = parent.querySelector("span").innerText;
  const img = parent.querySelector("img").src;
  const url = parent.dataset.value;

  select.querySelector('img').src = img
  // select.querySelector('span').innerText = value

  options.classList.toggle("active");
  
  window.location.href = url
});

document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('mouseover', function (event) {
    const target = event.target.closest('.mega-menu__nav .has_menu_img.link-faded');

    if (target) {
      const menuImage = target.getAttribute('data-menu-image');
      // console.log("menu_image == ", menuImage);

      // Optional decode
      // const decodedUrl = decodeURIComponent(menuImage);

      const megaMenu = target.closest('.mega-menu');
      if (megaMenu) {
        const imageElement = megaMenu.querySelector('.navigation-promo__wrapper img');
        if (imageElement) {
          imageElement.setAttribute('srcset', menuImage); // or decodedUrl
          imageElement.setAttribute('src', menuImage);    // or decodedUrl
        }
      }
    }
  });
});

setInterval(function () {
  const c_seconds = new Date().getTime(); // Get timestamp in milliseconds
  // console.log(c_seconds);
  const time_selector = document.querySelectorAll(".unik_bundle_time");
  time_selector.forEach(e => {
    e.value = c_seconds;
  });
}, 500);


// Handle custom quantity dropdown change
document.addEventListener("change", function(event) {
  // === QTY DROPDOWN (CUSTOM) ===
  const qtyDropdown = event.target.closest('line-item .custom_qty_update .quantity-dropdown');
  if (qtyDropdown && event.target === qtyDropdown) {
    const wrapper = event.target.closest('line-item .custom_qty_update');
    if (!wrapper) return;

    const lineKeys = wrapper.dataset.lineKey.split(',').map(key => key.trim());
    const newQty = parseInt(qtyDropdown.value) || 1;

    const updates = {};
    lineKeys.forEach(key => {
      updates[key] = newQty;
    });

    fetch('/cart/update.js?custom_update_the_qty_and_data', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify({ updates, sections: ['cart-drawer'] }),
    }).then(res => res.json()).then(cart => {
      const event = new CustomEvent('cart:updated', {
        detail: {
          cart,
          baseEvent: 'custom:update'
        }
      });
      document.querySelector('cart-drawer')?._onCartChanged?.(event);
    });

    return;
  }
});

document.addEventListener("click", function(event) {
  // === QTY BUTTONS ===
  const plusBtn = event.target.closest('line-item .custom_qty_update .plus');
  const minusBtn = event.target.closest('line-item .custom_qty_update .minus');

  if (plusBtn || minusBtn) {
    event.preventDefault();

    const wrapper = event.target.closest('line-item .custom_qty_update');
    if (!wrapper) return;

    const input = wrapper.querySelector('.quantity-input');
    if (!input) return;

    const lineKeys = wrapper.dataset.lineKey.split(',').map(key => key.trim());
    let newQty = parseInt(input.value) + (plusBtn ? 1 : -1);
    newQty = newQty < 1 ? 1 : newQty;
    input.value = newQty;

    const updates = {};
    lineKeys.forEach(key => {
      updates[key] = newQty;
    });

    fetch('/cart/update.js?custom_update_the_qty_and_data', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify({ updates, sections: ['cart-drawer'] }),
    }).then(res => res.json()).then(cart => {
      const event = new CustomEvent('cart:updated', {
        detail: {
          cart,
          baseEvent: 'custom:update'
        }
      });
      document.querySelector('cart-drawer')?._onCartChanged?.(event);
    });

    return;
  }

  // === REMOVE BUTTON ===
  const trashBtn = event.target.closest('.trash_data.custom_remove_btn .link');
  if (trashBtn) {
    event.preventDefault();

    const wrapper = event.target.closest('.trash_data.custom_remove_btn');
    if (!wrapper) return;


    const bundleId = wrapper.closest('line-item')?.getAttribute('bundle_id');
    console.log("bundleId", bundleId);

    const lineItems = document.querySelectorAll(`line-item[bundle_id="${bundleId}"]`);
    console.log("lineItems", lineItems);



    const updates = {};
    lineItems.forEach(item => {
      let pbundleId= item.getAttribute('bundle_id');
      let pbundleKey= item.getAttribute('line-key');
      console.log("item",pbundleKey, bundleId,pbundleId);
      // const lineKeys = item.dataset.lineKey.split(',').map(key => key.trim());
     
        if(bundleId==pbundleId){
          updates[pbundleKey] = 0;
        }
    });
    // const lineKeys = wrapper.dataset.lineKey.split(',').map(key => key.trim());
    // const updates = {};
    // lineKeys.forEach(key => {
    //   if
    //   updates[key] = 0;
    // });

    console.log("updates", updates);

    fetch('/cart/update.js?custom_remove_line_items', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify({ updates, sections: ['cart-drawer'] }),
    }).then(res => res.json()).then(cart => {
      const event = new CustomEvent('cart:updated', {
        detail: {
          cart,
          baseEvent: 'custom:remove'
        }
      });
      document.querySelector('cart-drawer')?._onCartChanged?.(event);
    });

    return;
  }

  // === Comparison Modal Open Trigger ===
  const comparisonTrigger = event.target.closest(".comparison_trigger");
  const comparisonModal = document.querySelector("#comparison_modal");
  const comparisonModalOverlay = event.target.closest(".comparison_modal_overlay");
  const comparisonModalCloseBTN = event.target.closest("#comparison_modal_close");

  if (comparisonTrigger) {
    const comparisonModal = document.querySelector("#comparison_modal");
    if (comparisonModal) {
      comparisonModal.classList.add("active");
      document.body.classList.add("no_scroll");
      equalizeComparisonHeights();
    }
  }
  if (comparisonModalOverlay || comparisonModalCloseBTN) {
    console.log("000000000");
    if (comparisonModal) {
      closeModal(comparisonModal);
    }
  }

});

class NewComparisonSection extends HTMLElement {
  products = [];

  connectedCallback() {
    this.dropdowns = this.querySelectorAll(".comparison_selection select");
    this.items = this.querySelectorAll("[data-item]");

    // Assign listeners for all dropdowns
    this.dropdowns.forEach((dropdown, index) => {
      dropdown.addEventListener("change", () => this.fetchProduct(dropdown, index));
    });

    // Optional controls container
    this.controls = this.querySelector(".comparison_controls");
  }

  fetchProduct(dropdown, index) {
    const item = this.items[index]; // match dropdown to item slot
    if (!item) return;

    item.classList.add("loading");
     // Fade out before fetching
    item.style.opacity = "0";
    const handle = dropdown.value;

    fetch(`/products/${handle}?view=ajex_comparison`)
      .then((res) => res.text())
      .then((res) => {
        const parser = new DOMParser();
        const htmlDoc = parser.parseFromString(res, "text/html");
        const newItem = htmlDoc.querySelector("[data-item]");
        if (newItem) {
          setTimeout(() => {
            item.innerHTML = newItem.innerHTML;
            item.style.opacity = "1";
            equalizeComparisonHeights();
          }, 300);          
        }
      })
      .catch(() => {
        item.classList.remove("loading");
      })
      .finally(() => {
        item.classList.remove("loading");
      });
  }

  removeProduct(value) {
    if (!this.dropdowns.length) return;

    this.dropdowns.forEach((dropdown) => {
      const options = Array.from(dropdown.querySelectorAll("option"));

      options.forEach((opt) => {
        if (opt.value === value) {
          if (!this.products.some((p) => p.handle === value)) {
            this.products.push({
              handle: value,
              title: opt.textContent,
            });
          }
          opt.remove();
        }
      });

      if (dropdown.options.length < 2 && this.controls) {
        this.controls.remove();
      }
    });
  }
}
document.addEventListener("DOMContentLoaded", function () {
  customElements.define("product-comparison", NewComparisonSection);
});

function equalizeComparisonHeights() {
  const mainItems = document.querySelectorAll(".main_comparison_dom .data_item");
  const otherItems = document.querySelectorAll(".other_comparison_dom .data_item");

  // Reset inline heights before calculation
  mainItems.forEach(item => item.style.height = "auto");
  otherItems.forEach(item => item.style.height = "auto");

  const count = Math.min(mainItems.length, otherItems.length);

  for (let i = 0; i < count; i++) {
    const mainHeight = mainItems[i].offsetHeight;
    const otherHeight = otherItems[i].offsetHeight;
    const maxHeight = Math.max(mainHeight, otherHeight);

    mainItems[i].style.height = maxHeight + "px";
    otherItems[i].style.height = maxHeight + "px";
  }
}
document.addEventListener("DOMContentLoaded", equalizeComparisonHeights);
window.addEventListener("resize", equalizeComparisonHeights);

function closeModal(modal) {
  if (!modal) return;
  modal.classList.add("closing");
  modal.addEventListener("animationend", () => {
    modal.classList.remove("active", "closing");
    document.body.classList.remove("no_scroll");
  }, { once: true });
}


// =============== Footer Newletter Form Checkbox =============== //
document.addEventListener("DOMContentLoaded", function () {
  const checkbox = document.querySelector('#customer_accepts_marketing');
  const submitBtn = document.querySelector('.footer .wac_form_wrap .button');

  if (!checkbox || !submitBtn) return;

  // Initial state
  submitBtn.disabled = !checkbox.checked;

  checkbox.addEventListener('change', function () {
    if (this.checked) {
      submitBtn.removeAttribute('disabled');
    } else {
      submitBtn.setAttribute('disabled', 'disabled');
    }
  });
});
